"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require('hacktimer');
require('bootstrap');
require('bootstrap-css');
require('webpack-jquery-ui');
require('webpack-jquery-ui/css');
require('../../../ui/js/chart.min.js');
require('../../../ui/js/jquery-ui.js');
require('../../../ui/js/jquery.mCustomScrollbar.js');
require('../../../ui/js/charts.js');
var internet_loss_warn_1 = require("../../../ui/js/internet-loss-warn");
internet_loss_warn_1.listenOnline();
window['terminal'] = false;
if (document.URL.indexOf("terminal.html") >= 0) {
    window['terminal'] = true;
}
window['lang'] = getUrlParameter('lang');
require('../../../ui/js/language.js');
require('../js/script.js');
require('../js/menu.js');
require('../js/charts.js');
require('../js/dograce.js');
require('../../../ui/js/iframe-script.js');
if (window['terminal']) {
    require('../js/terminal.js');
}
window['API_URL'] = API_URL;
window['$'] = require('jquery');
window['jquery'] = window['$'];
window['jQuery'] = window['$'];
require.context('../img', true, /\.(gif|png|jpe?g|svg)$/i);
require('../scss/' + CSS_THEME + '.scss');
switch (window.location.hostname) {
    case 'online.elbetdev.com':
        try {
            require('../scss/' + CSS_THEME + '/' + BABAIJEBU_DOMAIN + '.scss');
        }
        catch (e) {
            console.info(e);
        }
        break;
    case BABAIJEBU_DOMAIN:
        try {
            require('../scss/' + CSS_THEME + '/' + BABAIJEBU_DOMAIN + '.scss');
        }
        catch (e) {
            console.info(e);
        }
        break;
    case AMELCO_DOMAIN:
        try {
            require('../scss/' + CSS_THEME + '/' + AMELCO_DOMAIN + '.scss');
        }
        catch (e) {
            console.info(e);
        }
        break;
}
require('../../../ui/css/jquery.mCustomScrollbar.css');
window['customLoggedIn'] = false;
window['customToken'] = '';
window['token'] = getUrlParameter('token');
if (!/terminal/.test(window.location.href)) {
    document.documentElement.style.height = 'auto';
    document.getElementsByTagName("html")[0].style.overflow = 'auto';
    document.getElementsByTagName("body")[0].style.overflow = 'auto';
    document.getElementById('wrapper').style.height = 'auto';
}
if (/electron=true/.test(window.location.href)) {
    document.querySelector('.dr-game-holder-bar') ?
        document.querySelector('.dr-game-holder-bar').style.display = 'none' : '';
    document.querySelector('.dr-parent-bet-hold') ?
        document.querySelector('.dr-parent-bet-hold').style.height = '85%' : '';
}
function getUrlParameter(name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
        return null;
    }
    else {
        return decodeURI(results[1]) || 0;
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/games/dog-racing/ts/main.ts
// module id = 1548
// module chunks = 8